import { useAdminTenantDetails } from '@hakimo-ui/hakimo/data-access';
import { NotFound, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Page } from '@hakimo-ui/hakimo/ui-layout';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DeleteLocationCard } from './cards/DeleteLocationCard';
import { LocationInfoCard } from './cards/LocationInfoCard';
import { EditLocation } from './EditLocation';

interface Params extends Record<string, string> {
  tenantId: string;
  locationId: string;
}

export function LocationAdminDetails() {
  const { tenantId, locationId } = useParams<Params>();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);

  const onClickBack = () => {
    navigate(-1);
  };

  const handleClickEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleEditSuccess = () => {
    setIsEditing(false);
  };

  const queryResult = useAdminTenantDetails(tenantId!);

  return (
    <QueryResult queryResult={queryResult}>
      {(tenant) => {
        const location = tenant?.locations.find(
          (loc) => loc.id.toString() === locationId
        );

        if (!location) {
          return <NotFound />;
        }

        if (isEditing) {
          return (
            <EditLocation
              tenantId={tenantId!}
              location={location}
              onCancel={handleCancelEdit}
              onSuccess={handleEditSuccess}
            />
          );
        }

        return (
          <Page
            title={location.name}
            subtitle="Tenant / Location"
            onClickBack={onClickBack}
          >
            <div className="bg-hakimo-light-bg dark:bg-hakimo-dark-bg flex h-full justify-center py-6">
              <div className="w-full max-w-6xl space-y-6 px-4">
                <LocationInfoCard
                  location={location}
                  onEditClick={handleClickEdit}
                />
                {tenant.isActive && (
                  <DeleteLocationCard
                    locationId={location.id}
                    tenantId={tenantId!}
                  />
                )}
              </div>
            </div>
          </Page>
        );
      }}
    </QueryResult>
  );
}

export default LocationAdminDetails;
